import type { Sensor } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

export const sensorService = {
  list: (
    tenantId: string,
    params: { limit?: number; startAfter?: string } = {}
  ): Promise<PaginatedResult<WithId<Sensor>>> =>
    api.getPaginated<WithId<Sensor>>(withTenant('/sensors', tenantId, params)),
};
